import React from 'react';
import styles from './FubConnectionLogo.module.scss';
import { SimpleBlock } from 'ui-builder';

export function FubConnectionLogo(props: {
  title: string,
  onClick?: () => void,
}) {
  return (
    <SimpleBlock
      className={[styles.logo, props.onClick ? styles.clickable : ''].join(' ')}
      title={props.title}
      onClick={props.onClick}
    />
  )
}
